define("ember-in-viewport/utils/can-use-raf", ["exports", "ember-in-viewport/utils/can-use-dom"], function (_exports, _canUseDom) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = canUseRAF;
  0; //eaimeta@70e063a35619d71f0,"ember-in-viewport/utils/can-use-dom"eaimeta@70e063a35619d71f
  // Adapted from Paul Irish's rAF polyfill
  // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
  // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
  // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
  // MIT license
  function checkRAF(window, rAF, cAF) {
    let x;
    let vendors = ['ms', 'moz', 'webkit', 'o'];
    for (x = 0; x < vendors.length && !window[rAF]; ++x) {
      window[rAF] = window[`${vendors[x]}RequestAnimationFrame`];
      window[cAF] = window[`${vendors[x]}CancelAnimationFrame`] || window[`${vendors[x]}CancelRequestAnimationFrame`];
    }
    if (window[rAF] && window[cAF]) {
      return true;
    } else {
      return false;
    }
  }
  function canUseRAF() {
    if (!_canUseDom.default) {
      return false;
    }
    return checkRAF(window, 'requestAnimationFrame', 'cancelAnimationFrame');
  }
});